const cloudRevenueStatuses = {
	LIVE: "live",
	INACTIVE: "inactive",
};

export default cloudRevenueStatuses;
